import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { ErrorMessage as FoundationsErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import ErrorMessage from '../alerts/ErrorMessage';
import LoginLoading from '../LoginLoading';
import ReturnLink from '../ReturnLink';
import { ERROR_COPY, LOADING_COPY, PAGE_HEADER } from './loginTypeConstants';
import { useConfirmationLanding } from './useConfirmationLanding';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LoginConfirmationLandingAndRedirect = ({
  loginType = 'MICROSOFT'
}) => {
  const {
    error,
    onLoad
  } = useConfirmationLanding(loginType);
  useEffect(() => {
    onLoad();
  }, [onLoad]);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: PAGE_HEADER[loginType],
    children: error ? /*#__PURE__*/_jsxs(FoundationsErrorMessage, {
      illustration: "errors/general",
      title: /*#__PURE__*/_jsx("h1", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: ERROR_COPY[loginType].header
        })
      }),
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "400",
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: ERROR_COPY[loginType].instructions
        })
      }), /*#__PURE__*/_jsx(ErrorMessage, {
        error: error
      }), /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: ERROR_COPY[loginType].navigate,
        options: {
          link: /*#__PURE__*/_jsx(ReturnLink, {})
        }
      })]
    }) : /*#__PURE__*/_jsxs(Text, {
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(LoginLoading, {
        message: LOADING_COPY[loginType].loadingMessageType
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: LOADING_COPY[loginType].confirming
      })]
    })
  });
};